import * as React from 'react';
import { Pressable, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import type { TxKeyPath } from '@/core';
import { Text } from '@/ui';

interface ListItemProps {
  tx?: TxKeyPath;
  text?: string;
  onPress: () => void;
  icon?: React.ReactNode;
  disabled?: boolean;
  withBorder?: boolean;
  style?: any;
  textStyle?: any;
  caption?: string;
  captionStyle?: any;
  button?: any;
}

export const ListItem = ({
  tx,
  text,
  onPress,
  icon,
  disabled = false,
  withBorder = true,
  style,
  textStyle,
  caption,
  captionStyle,
  button,
}: ListItemProps) => {
  const { styles, theme } = useStyles(stylesheet);
  const [hover, setHover] = React.useState(false);

  return (
    <Pressable
      hitSlop={8}
      onPress={onPress}
      onHoverIn={() => setHover(true)}
      onHoverOut={() => setHover(false)}
      style={({ pressed }) => [
        styles.container,
        { opacity: pressed ? 0.5 : 1, cursor: 'pointer' },
        style,
      ]}
      disabled={disabled}
    >
      <View
        style={{
          flexDirection: 'row',
          gap: 8,
          justifyContent: 'space-between',
        }}
      >
        <View
          style={{
            flexShrink: 1,
            flexDirection: 'row',
            gap: 8,
          }}
        >
          {icon}

          <View
            style={{
              flexShrink: 1,
              justifyContent: 'center',
            }}
          >
            {tx ? (
              <Text
                type="bodyRegular"
                tx={tx}
                style={[
                  disabled && {
                    color: theme.colors.button.primary.disabled.text,
                  },
                  textStyle,
                ]}
              />
            ) : (
              <Text
                type="bodyRegular"
                style={[
                  disabled && {
                    color: theme.colors.button.primary.disabled.text,
                  },
                  textStyle,
                ]}
              >
                {text}
              </Text>
            )}

            {caption ? (
              <Text
                type="caption1"
                style={{ color: theme.colors.text.secondary, ...captionStyle }}
              >
                {caption}
              </Text>
            ) : null}
          </View>
        </View>

        {button ? <View>{button}</View> : null}
      </View>

      {withBorder && (
        <View
          style={{
            backgroundColor: theme.colors.card.default.borderColor,
            height: 0.4,
            width: '100%',
          }}
        />
      )}
    </Pressable>
  );
};

const stylesheet = createStyleSheet((theme) => ({
  container: {
    flexDirection: 'column',
    gap: 16,
  },
}));
